window.topFunction = function() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

var stepTime = 20;
var docBody = document.body;
var focElem = document.documentElement;

window.scrollAnimationStep = function (initPos, stepAmount) {
    var newPos = initPos - stepAmount > 0 ? initPos - stepAmount : 0;
    docBody.scrollTop = focElem.scrollTop = newPos;
    newPos && setTimeout(function () {
        scrollAnimationStep(newPos, stepAmount);
    }, stepTime);
}

window.scrollTopAnimated = function (speed) {
    var topOffset = docBody.scrollTop || focElem.scrollTop;
    var stepAmount = topOffset;
    speed && (stepAmount = (topOffset * stepTime)/speed);
    scrollAnimationStep(topOffset, stepAmount);
    if (document.body.classList.contains('mdi-main-page') && (window.dataLayer = window.dataLayer || [])) {
        dataLayer.push({'event':'gaEvent', 'eventCategory':'interest', 'eventAction':'click_link', 'eventLabel':'Back to top'});
    }
};

window.scrollToId = function (speed,id) {
    var topOffset = docBody.scrollTop || focElem.scrollTop;
    var stepAmount = topOffset;
    speed && (stepAmount = (topOffset * stepTime)/speed);
    scrollAnimationStep(topOffset, stepAmount);
    if (document.body.classList.contains('mdi-main-page') && (window.dataLayer = window.dataLayer || [])) {
        dataLayer.push({'event':'gaEvent', 'eventCategory':'interest', 'eventAction':'click_link', 'eventLabel':'Back to top'});
    }
};